// =============================================================================
// Task Types
// =============================================================================
export const TASK_STATUSES = [
    'draft',
    'ready',
    'queued',
    'delegated',
    'in_progress',
    'completed',
    'failed',
    'cancelled',
];
/** Runtime type guard for TaskStatus values from untrusted sources (e.g. database rows). */
export function isTaskStatus(value) {
    return typeof value === 'string' && TASK_STATUSES.includes(value);
}
export const TASK_MODES = ['task', 'conversation'];
/** Runtime type guard for TaskMode values from untrusted sources (e.g. database rows). */
export function isTaskMode(value) {
    return typeof value === 'string' && TASK_MODES.includes(value);
}
/**
 * Tracks where the task runner is during async execution.
 * Persisted to the task record so stuck-task recovery knows WHERE execution stalled.
 */
export const TASK_EXECUTION_STEPS = [
    'node_selection',
    'node_provisioning',
    'node_agent_ready',
    'workspace_creation',
    'workspace_ready',
    'attachment_transfer',
    'agent_session',
    'running',
    'awaiting_followup',
];
export function isTaskExecutionStep(value) {
    return typeof value === 'string' && TASK_EXECUTION_STEPS.includes(value);
}
/** Human-readable labels for each execution step (TDF-8). */
export const EXECUTION_STEP_LABELS = {
    node_selection: 'Finding a server...',
    node_provisioning: 'Setting up a new server...',
    node_agent_ready: 'Waiting for server to start...',
    workspace_creation: 'Creating workspace...',
    workspace_ready: 'Setting up development environment...',
    attachment_transfer: 'Uploading attachments to workspace...',
    agent_session: 'Starting AI agent...',
    running: 'Agent is working...',
    awaiting_followup: 'Waiting for follow-up...',
};
/** Ordered index for execution step progress — derived from TASK_EXECUTION_STEPS array position (TDF-8). */
export const EXECUTION_STEP_ORDER = Object.fromEntries(TASK_EXECUTION_STEPS.map((step, i) => [step, i]));
/** Default attachment size/count limits — all overridable via env vars. */
export const ATTACHMENT_DEFAULTS = {
    /** Maximum file size per attachment in bytes (default: 50MB). Env: ATTACHMENT_UPLOAD_MAX_BYTES */
    UPLOAD_MAX_BYTES: 50 * 1024 * 1024,
    /** Maximum total batch size in bytes (default: 200MB). Env: ATTACHMENT_UPLOAD_BATCH_MAX_BYTES */
    UPLOAD_BATCH_MAX_BYTES: 200 * 1024 * 1024,
    /** Maximum number of files per task (default: 20). Env: ATTACHMENT_MAX_FILES */
    MAX_FILES: 20,
    /** Presigned URL expiry in seconds (default: 900 = 15min). Env: ATTACHMENT_PRESIGN_EXPIRY_SECONDS */
    PRESIGN_EXPIRY_SECONDS: 900,
};
/** Regex for safe filenames — matches the VM agent pattern. */
export const SAFE_FILENAME_REGEX = /^[a-zA-Z0-9._\- ]+$/;
//# sourceMappingURL=task.js.map